import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip, TablePagination, TextField, FormControl, InputLabel, Select, MenuItem, Chip } from '@mui/material';
import { Edit, Delete, Visibility, Description } from '@mui/icons-material';
import { Document } from '../../types';

interface DocumentsTableProps {
  items: Document[];
  loading: boolean;
  total: number;
  page: number;
  limit: number;
  onPageChange: (page: number) => void;
  onEdit: (item: Document) => void;
  onDelete: (id: number) => void;
}

export function DocumentsTable({ items, loading, total, page, limit, onPageChange, onEdit, onDelete }: DocumentsTableProps) {
  const formatFileSize = (size?: string) => {
    if (!size) return '-';
    return size;
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Название</TableCell>
            <TableCell>Категория</TableCell>
            <TableCell>Файл</TableCell>
            <TableCell>Размер</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <TableRow key={item.id} hover>
              <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Description color="action" />
                  {item.title}
                </Box>
              </TableCell>
              <TableCell>
                {item.category ? (
                  <Chip label={item.category} size="small" />
                ) : '-'}
              </TableCell>
              <TableCell>
                {item.fileUrl ? (
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: 'primary.main',
                      cursor: 'pointer',
                      textDecoration: 'underline'
                    }}
                    onClick={() => window.open(item.fileUrl, '_blank')}
                  >
                    Открыть
                  </Typography>
                ) : '-'}
              </TableCell>
              <TableCell>{formatFileSize(item.fileSize)}</TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Tooltip title="Просмотр">
                    <IconButton size="small" onClick={() => item.fileUrl && window.open(item.fileUrl, '_blank')}>
                      <Visibility fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Редактировать">
                    <IconButton size="small" onClick={() => onEdit(item)}>
                      <Edit fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Удалить">
                    <IconButton size="small" onClick={() => onDelete(item.id)} sx={{ color: 'error.main' }}>
                      <Delete fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
          {items.length === 0 && !loading && (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography color="text.secondary">Данные не найдены</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={total}
        page={page - 1}
        onPageChange={(_, newPage) => onPageChange(newPage + 1)}
        rowsPerPage={limit}
        onRowsPerPageChange={() => {}}
        rowsPerPageOptions={[]}
      />
    </TableContainer>
  );
}

interface DocumentsToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  categoryFilter: string;
  onCategoryFilterChange: (value: string) => void;
}

export function DocumentsToolbar({ search, onSearchChange, categoryFilter, onCategoryFilterChange }: DocumentsToolbarProps) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2, alignItems: 'center' }}>
      <TextField
        label="Поиск"
        variant="outlined"
        size="small"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ minWidth: 200 }}
      />
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel>Категория</InputLabel>
        <Select
          value={categoryFilter}
          label="Категория"
          onChange={(e) => onCategoryFilterChange(e.target.value as string)}
        >
          <MenuItem value="">Все</MenuItem>
          <MenuItem value="official">Официальные</MenuItem>
          <MenuItem value="legal">Юридические</MenuItem>
          <MenuItem value="financial">Финансовые</MenuItem>
          <MenuItem value="other">Другие</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}